import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

// Restates borders/disabled that MuiTextField's styleOverrides also set — that
// block is shared with every non-rewamp form and still holds literals, so it's
// overridden here rather than changed there.
const RewampTextField = styled(TextField)(({ theme }) => ({
  // Opts this field's placeholder into the form's darker tone. The app-wide
  // MuiInputBase rule reads this variable and falls back to
  // neutral.placeholder, so search/login/DBT are untouched — and the value
  // inherits, so no specificity fight with that baseline.
  "--rewampPlaceholder": theme.palette.formText.placeholder,

  "& .MuiOutlinedInput-root": {
    height: "40px",
    backgroundColor: theme.palette.background.paper,

    "& input": {
      padding: `${theme.spacingTokens["md-sm"]} ${theme.spacingTokens.md}`,
      color: theme.palette.formText.input,
      WebkitTextFillColor: theme.palette.formText.input,
      backgroundColor: "transparent",
    },

    // NEVER give the notched outline a background: MUI renders it as the LAST
    // child, absolutely positioned with no z-index, so an opaque fill paints
    // over the input's own text and the field renders blank. The root above
    // already carries the surface.
    "& fieldset": {
      borderColor: theme.palette.neutral.stroke,
      borderRadius: "8px",
    },
    "&:hover fieldset, &.Mui-focused fieldset": {
      borderColor: theme.palette.primary.interactive,
    },

    "&.Mui-disabled": {
      "& input": {
        cursor: "not-allowed",
        // Disabled here means "prefilled from DBT, not editable" — the value is
        // data the applicant must read, so it keeps body-text contrast.
        // text.disabled is 2.28:1 on disabledSurface in light mode.
        color: theme.palette.text.textGrey,
        WebkitTextFillColor: theme.palette.text.textGrey,
      },
      backgroundColor: theme.palette.neutral.disabledSurface,
      "& fieldset, &:hover fieldset": {
        borderColor: theme.palette.neutral.disabled,
      },
    },
  },

  "& .MuiInputAdornment-root": {
    zIndex: 2,
    backgroundColor: theme.palette.background.paper,
  },

  "& .MuiFormHelperText-root.Mui-error": {
    color: theme.palette.formMessage.error,
  },

  // Long transition is the standard defeat for Chrome's autofill repaint.
  "& input:-webkit-autofill, & input:-internal-autofill-selected": {
    WebkitTextFillColor: theme.palette.formText.input,
    WebkitBoxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset`,
    transition: "background-color 5000s ease-in-out 0s",
  },
}));

export default RewampTextField;
